import { render, staticRenderFns } from "./GetSlide2.vue?vue&type=template&id=56e44b43&scoped=true&"
import script from "./GetSlide2.vue?vue&type=script&lang=js&"
export * from "./GetSlide2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e44b43",
  null
  
)

export default component.exports